import CrudApiClient from './crudapiclient';
import { GATEWAY_API_URL } from '@admin-panel/config/env';
import { axiosInstance } from './axios';

class GatepassApiClient extends CrudApiClient {
  constructor() {
    super(GATEWAY_API_URL + '/wms/gatepass');
  }

  protected transformNode(node: any) {
    // Transform gatepass data if needed
    return node;
  }

  // Custom methods for gatepass specific operations
  async findByGatepassOrderId(gatepassOrderId: string) {
    return axiosInstance.get(`${this.baseURL}/by-order/${gatepassOrderId}`);
  }

  async submitPorterLink(id: string, porterLink: string) {
    return axiosInstance.post(
      `${GATEWAY_API_URL}/wms/gatepassorder/gatepass/${id}/mark-in-transit`,
      { porterLink },
    );
  }

  async updateStatus(id: string, status: string) {
    return axiosInstance.patch(`${this.baseURL}/${id}/status`, { status });
  }

  // Handle submit-porter-link action
  async 'submit-porter-link'(
    sorters: any,
    filters: any,
    payload: any,
    query: any,
    headers: any,
    meta: any,
  ) {
    if (meta?.gatepassId) {
      const response = await axiosInstance.post(
        `${GATEWAY_API_URL}/wms/gatepassorder/gatepass/${meta.gatepassId}/mark-in-transit`,
        payload,
      );
      return response.data;
    }
    throw new Error('gatepassId is required for submit-porter-link action');
  }

  // Handle mark-received action
  async 'mark-received'(
    sorters: any,
    filters: any,
    payload: any,
    query: any,
    headers: any,
    meta: any,
  ) {
    if (meta?.gatepassId) {
      const response = await axiosInstance.post(
        `${GATEWAY_API_URL}/wms/gatepassorder/gatepass/${meta.gatepassId}/mark-received`,
        payload,
      );
      return response.data;
    }
    throw new Error('gatepassId is required for mark-received action');
  }

  // Handle mark-delivered action
  async 'mark-delivered'(
    sorters: any,
    filters: any,
    payload: any,
    query: any,
    headers: any,
    meta: any,
  ) {
    if (meta?.gatepassId) {
      const response = await axiosInstance.post(
        `${GATEWAY_API_URL}/wms/gatepassorder/gatepass/${meta.gatepassId}/mark-delivered`,
        payload,
      );
      return response.data;
    }
    throw new Error('gatepassId is required for mark-delivered action');
  }
}

export default GatepassApiClient;
